import { render, staticRenderFns } from "./ViewDataModal.vue?vue&type=template&id=46870d6e&scoped=true"
import script from "./ViewDataModal.vue?vue&type=script&lang=js"
export * from "./ViewDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46870d6e",
  null
  
)

export default component.exports